module.exports = __webpack_public_path__ + "static/media/planta1.11ab83e7.png";